// extracted by mini-css-extract-plugin
export default {"defaultCard":"An-z","otherCards":"Bn-z","empty":"Cn-z","addNewItem":"Dn-z","disabled":"En-z","cardGrid":"Fn-z"};